<script setup lang="ts">
import { BaseSerializedChart, SerializedIRChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { SerializedGeneralChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { ref, Ref, watch } from 'vue'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { TagSelector } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'
import CameraTagSelector from '@/components/charts/chart-creator/CameraTagSelector.vue'
import { useDisplay } from 'vuetify'

const props = defineProps<{ baseSerialized: BaseSerializedChart | null; timeSetup: SerializedGeneralChartTimeSetup | null }>()
const model = defineModel<SerializedIRChart | null>()

const { mobile } = useDisplay()

const cameraTagSelector: Ref<TagSelector<'camera'>> = ref({ useAll: true, groupByValues: true, tag: 'camera', allowEmptyValues: false })

watch(
  () => [props.baseSerialized, props.timeSetup, cameraTagSelector],
  () => {
    if (!props.baseSerialized) return
    if (!props.timeSetup) return
    model.value = {
      ...props.baseSerialized,
      xAggregation: 'first',
      cameraTagSelector: cameraTagSelector.value,
      timeSetup: Object.assign({}, props.timeSetup, { fixedTimeResolution: 1000 * 60 }),
      chartType: CHART_TYPES.IR,
      seriesBasedHeight: true,
    }
  },
  { immediate: true, deep: true }
)
</script>

<template>
  <v-layout-card
    class="pa-0 mb-6"
    variant="flat"
    elevation="0"
  >
    <v-card-title class="pt-0">
      <v-icon icon="mdi-weather-night" />
      {{ $t('chart_sharing.creator.customize.chart_types.influx.ir') }}
    </v-card-title>
    <v-card-text
      class="py-0"
      :class="{ 'px-0': mobile, 'px-6': !mobile }"
    >
      <CameraTagSelector v-model="cameraTagSelector" />
    </v-card-text>
  </v-layout-card>
</template>
